"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormPluginType = void 0;
var FormPluginType;
(function (FormPluginType) {
  FormPluginType["CHECKBOX"] = "CHECKBOX";
  FormPluginType["TEXT"] = "TEXT";
  FormPluginType["SELECT"] = "SELECT";
  FormPluginType["SELECT_COUNTRY"] = "SELECT_COUNTRY";
  FormPluginType["INPUT_DATE"] = "INPUT_DATE";
  FormPluginType["INPUT_DATE_TIME"] = "INPUT_DATE_TIME";
  FormPluginType["INPUT_NUMBER"] = "INPUT_NUMBER";
  FormPluginType["INPUT_TEXT"] = "INPUT_TEXT";
  FormPluginType["INPUT_EMAIL"] = "INPUT_EMAIL";
  FormPluginType["INPUT_HIDDEN"] = "INPUT_HIDDEN";
  FormPluginType["TEXTAREA"] = "TEXTAREA";
  FormPluginType["ACTION_POST"] = "ACTION_POST";
  FormPluginType["ACTION_EMAIL"] = "ACTION_EMAIL";
  FormPluginType["ACTION_DB"] = "ACTION_DB";
})(FormPluginType = exports.FormPluginType || (exports.FormPluginType = {}));